export default __webpack_public_path__ + "static/media/Metropolis-Bold.c5e04faf.otf";